import {Component, Input} from '@angular/core';

@Component({
	selector: 'amd-items-counter',
	templateUrl: './items-counter.component.html',
	styleUrls: ['./items-counter.component.scss']
})
export class ItemsCounterComponent {

	@Input() subtitle: string;
	@Input() title: string;
	@Input() icon: string;
	@Input() isLarge: boolean;
	@Input() class: string;
	@Input() stepCounto: number;
	@Input() showLoader: boolean;
	@Input() model: ItemCounterModel;

	invertToFrom(index: number) {
		if (this.showLoader) {
			const oldValueFrom = this.model.valueFrom;
			this.model.valueFrom = this.model.valueTo;
			this.model.valueTo = oldValueFrom;
		}
	}
}

export interface ItemCounterModel {
	count: number;
	valueFrom: number;
	valueTo: number;
	time: number;
	code?: any;
}
